"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const butterfly_json_1 = __importDefault(require("./butterfly.json"));
const chessboard_json_1 = __importDefault(require("./chessboard.json"));
const christmas_tree_json_1 = __importDefault(require("./christmas-tree.json"));
const complex_json_1 = __importDefault(require("./complex.json"));
const floral_json_1 = __importDefault(require("./floral.json"));
const tree_json_1 = __importDefault(require("./tree.json"));
const examples = [
    {
        name: "Butterfly",
        rules: butterfly_json_1.default
    },
    { name: "Chess", rules: chessboard_json_1.default },
    { name: "Christmas Tree", rules: christmas_tree_json_1.default, yOffset: -1 },
    { name: "Complex", rules: complex_json_1.default },
    { name: "Floral", rules: floral_json_1.default },
    { name: "Tree", rules: tree_json_1.default, yOffset: -1 }
];
exports.default = examples;



// WEBPACK FOOTER //
// ./src/data/examples/_examples.ts